import { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { withTranslation } from 'react-i18next';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import MainLayout from 'layouts/MainLayout';
import { BrowserRouter } from 'react-router-dom'; // Use BrowserRouter instead
import { store } from './redux/store'; // No need for custom history
import { renderRoutes, routes } from './routes';
import ThemeConfig from './theme';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import JwtProvider from './components/authentication/JwtProvider';
import Notifier from './components/Notifier';

import './App.scss';

function App({ tReady }: { tReady?: boolean }) {
  const [home, setHome] = useState<boolean>(false);

  return (
    <HelmetProvider>
      {/*  eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ReduxProvider store={store} children={undefined}>
        <ThemeConfig home={home}>
          <RtlLayout>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <NotistackProvider>
                <Notifier />
                <BrowserRouter>
                  <MainLayout location={setHome}>
                    {tReady ? (
                      <JwtProvider>
                        <ScrollToTop />
                        <GoogleAnalytics />
                        {renderRoutes(routes)}
                      </JwtProvider>
                    ) : (
                      <LoadingScreen />
                    )}
                  </MainLayout>
                </BrowserRouter>
              </NotistackProvider>
            </LocalizationProvider>
          </RtlLayout>
        </ThemeConfig>
      </ReduxProvider>
    </HelmetProvider>
  );
}

export default withTranslation()(App);
